import PropTypes from 'prop-types';
import { at } from 'lodash';
import { useField } from 'formik';
import {
  FormControl,
  TextField,
  FormHelperText,
  Autocomplete
} from '@mui/material';

export default function SelectField(props) {
  const { label, data, ...rest } = props;
  const [field, meta, helpers] = useField(props);
  const { setValue } = helpers;

  const [touched, error] = at(meta, 'touched', 'error');
  const isError = touched && Boolean(error);

  const fieldId = props.name;
  const helperId = `${fieldId}-helper-text`;

  // Find the selected option object from the value
  const selectedOption = data.find(option => option.value === field.value) || null;

  return (
    <FormControl
      {...rest}
      fullWidth
      error={isError}
    >
      <Autocomplete
        id={fieldId}
        options={data}
        getOptionLabel={(option) => option.label || ''}
        value={selectedOption}
        onChange={(event, newValue) => {
          setValue(newValue ? newValue.value : '');
        }}
        onBlur={field.onBlur}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        disablePortal
        componentsProps={{
          popper: {
            placement: 'bottom-start',
            modifiers: [
              {
                name: 'flip',
                enabled: false,
              },
            ],
          },
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            name={field.name}
            label={label}
            error={isError}
            aria-describedby={isError ? helperId : undefined}
          />
        )}
      />

      {isError && (
        <FormHelperText id={helperId}>
          {error}
        </FormHelperText>
      )}
    </FormControl>
  );
}

SelectField.defaultProps = {
  data: []
};

SelectField.propTypes = {
  data: PropTypes.array.isRequired
};

